import { NAME_SPACES, useTranslationNameSpace } from 'i18n/hooks';
import {
  COLORS,
  FlexColumn,
  TEXT_TYPES,
  TEXT_WEIGHTS,
  Text,
  FlotableElement,
  Square,
  Button,
  BUTTON_TYPES,
} from 'modules/ui/components';
import { PageTitle } from 'modules/ui/components/PageTitle';
import { useCallback } from 'react';
import { settings, terms } from './utils';

export const DesktopCookiesPolicy = () => {
  const { t } = useTranslationNameSpace(NAME_SPACES.PAGES);

  const onPrint = useCallback(() => window.print(), []);

  return (
    <FlexColumn w="100%" h="100%">
      <PageTitle title={t('cookiesPolicy.title')} />
      <FlexColumn
        w="100%"
        alignItems="center"
        position="relative"
        bgSize="cover"
        bg="url(./assets/backgrounds/background-4.png)"
      >
        <FlexColumn w="80%" m="100px 0" alignItems="center">
          {terms.map((items, i) => (
            <FlexColumn w="100%" gap="10px" m="40px 0">
              <Text
                size="25px"
                type={TEXT_TYPES.text}
                color={COLORS.white}
                weight={TEXT_WEIGHTS.bolder}
                lineHeight="40px"
                letterSpacing="1.12px"
                whiteSpace="pre-wrap"
              >
                {t(`cookiesPolicy.terms.${i}.title`)}
              </Text>
              {items.map((text, textIndex) => {
                return (
                  <Text
                    m="10px 0"
                    size="20px"
                    type={TEXT_TYPES.text}
                    color={COLORS.white}
                    weight={TEXT_WEIGHTS.tiny}
                    letterSpacing="0.92px"
                    lineHeight="40px"
                    whiteSpace="pre-wrap"
                  >
                    {t(`cookiesPolicy.terms.${i}.texts.${textIndex}`)}
                  </Text>
                );
              })}
            </FlexColumn>
          ))}
          <FlexColumn w="100%" m="100px 0">
            {settings.map((text, i) => (
              <Text
                m="7px"
                size="20px"
                type={TEXT_TYPES.text}
                color={COLORS.yellow}
                weight={TEXT_WEIGHTS.bolder}
                lineHeight="28px"
                whiteSpace="pre-wrap"
              >
                {t(`cookiesPolicy.settings.${i}`)}
              </Text>
            ))}
          </FlexColumn>
          <FlexColumn w="100%" gap="40px" alignItems="center">
            <img src="./assets/terms/print.png" alt="print" />
            <Button buttonType={BUTTON_TYPES.filled} onClick={onPrint}>
              {t(`cookiesPolicy.button`)}
            </Button>
          </FlexColumn>
        </FlexColumn>
        <FlotableElement left="87%" top="-8%">
          <Square zIndex="1" size="30vw" />
        </FlotableElement>
        <FlotableElement left="-27%" top="80%">
          <Square zIndex="1" size="30vw" />
        </FlotableElement>
      </FlexColumn>
    </FlexColumn>
  );
};
